import { render, staticRenderFns } from "./AgendaParcela.vue?vue&type=template&id=2d2201c8"
import script from "./AgendaParcela.vue?vue&type=script&lang=js"
export * from "./AgendaParcela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports